import $ from 'jquery';
import Api from '../utilities/Api';
import Popup from '../utilities/Popup';

let isGoogleCaptchaSuccess = false;

// google captcha
window.captchaSuccessCallback = () => {
    isGoogleCaptchaSuccess = true;
};

window.captchaExpireCallback = () => {
    isGoogleCaptchaSuccess = false;
};

if ($('.control--register-password input').length > 0) {
    $('.control--register-password input')[0].setCustomValidity('Значение поля должно быть 6 символов и более');

    $('.control--register-password input, .control--register-password-repeat input').keyup(function () {
        const inputPassword = $('.control--register-password input');
        const inputPasswordRepeat = $('.control--register-password-repeat input');
        const inputPasswordValue = inputPassword.val();
        const inputPasswordRepeatValue = inputPasswordRepeat.val();

        if (inputPasswordValue.length < 6) {
            inputPassword[0].setCustomValidity('Значение поля должно быть 6 символов и более');
            inputPasswordRepeat[0].setCustomValidity('');
        } else {
            if (inputPasswordValue != inputPasswordRepeatValue) {
                inputPassword[0].setCustomValidity('');
                inputPasswordRepeat[0].setCustomValidity('Пароли должны совпадать');
            } else {
                inputPassword[0].setCustomValidity('');
                inputPasswordRepeat[0].setCustomValidity('');
            }
        }
    });
}

let isRegistrationInProgress = false;
$('.register-form').submit(function (e) {
    e.preventDefault();

    if (isRegistrationInProgress) {
        return;
    }

    if (!isGoogleCaptchaSuccess) {
        Popup.notify('Пожалуйста, пройдите проверку Google reCAPTCHA');
        return;
    }

    isRegistrationInProgress = true;

    Popup.showContent('Регистрация', 'Пожалуйста подождите, идёт процесс регистрации...', 700, false);

    Api.post('/api/v2/account/register/', $(this).serializeObject()).then((response) => {
        if (response.isError) {
            Popup.showContent('Ошибка', response.error, 700, true);
        }
        // if (response.isSuccess) {
        //     window.location = `/register/verify?hash=${response.hash}`;
        // }
        isRegistrationInProgress = false;
    });
});
